import { Check, BedDouble, Home, TreePine, ArrowRight } from 'lucide-react';

const ICONS = { room200: Home, bo: BedDouble, cabin: TreePine };

export const TierCards = ({ tiers, holdHours, onSelect, selectedId }) => (
  <div className="grid md:grid-cols-3 gap-5 md:gap-6" data-testid="tier-cards">
    {tiers.map((tier, idx) => {
      const Icon = ICONS[tier.id] || BedDouble;
      const soldOut = tier.available <= 0;
      const low = !soldOut && tier.available <= 5;
      const featured = idx === 0;
      const selected = selectedId === tier.id;
      return (
        <button
          key={tier.id}
          type="button"
          disabled={soldOut}
          onClick={() => onSelect(tier)}
          data-testid={`tier-card-${tier.id}`}
          className={`group relative text-left rounded-2xl border transition-all duration-300 overflow-hidden focus:outline-none focus-visible:ring-2 focus-visible:ring-[#d9a15b]
            ${soldOut ? 'opacity-60 cursor-not-allowed border-gray-200 bg-white' : 'hover:-translate-y-1 hover:shadow-2xl'}
            ${featured && !soldOut ? 'bg-[#1a0d10] text-white border-[#d9a15b]/40 shadow-xl md:-mt-3 md:mb-[-12px]' : 'bg-white border-gray-200 shadow-md'}
            ${selected ? 'ring-2 ring-[#d9a15b]' : ''}`}
        >
          {featured && !soldOut && <div className="absolute inset-0 grain opacity-50 pointer-events-none" />}
          {soldOut && (
            <span className="absolute top-4 right-4 rounded-full bg-gray-900 text-white text-[10px] font-bold tracking-widest uppercase px-3 py-1">Sold out</span>
          )}
          {low && (
            <span className="absolute top-4 right-4 rounded-full bg-amber-100 text-amber-800 text-[10px] font-bold tracking-widest uppercase px-3 py-1">Only {tier.available} left</span>
          )}
          <div className="relative p-6 md:p-7">
            <div className={`w-11 h-11 rounded-xl flex items-center justify-center mb-6 ${featured && !soldOut ? 'bg-[#d9a15b]/15 text-[#d9a15b]' : 'bg-wine-50 text-wine'}`}>
              <Icon className="w-5 h-5" />
            </div>
            <p className={`eyebrow text-[10px] tracking-[0.25em] mb-2 ${featured && !soldOut ? 'text-[#d9a15b]' : 'text-gray-400'}`}>{tier.tagline || 'Bed reservation'}</p>
            <h3 className="font-display text-3xl font-semibold tracking-tight mb-1">{tier.name}</h3>
            <div className="flex items-baseline gap-1.5 mb-5">
              <span className="font-display text-5xl font-medium tracking-tighter">${tier.price}</span>
              <span className={`text-xs ${featured && !soldOut ? 'text-white/50' : 'text-gray-400'}`}>per bed</span>
            </div>
            <p className={`text-sm leading-relaxed mb-6 ${featured && !soldOut ? 'text-white/70' : 'text-gray-600'}`}>{tier.description}</p>
            <ul className={`space-y-2 text-sm mb-7 ${featured && !soldOut ? 'text-white/80' : 'text-gray-700'}`}>
              <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[#d9a15b]" />All meals & programming included</li>
              <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[#d9a15b]" />Held {holdHours} hours while you pay</li>
              <li className="flex items-center gap-2"><Check className="w-4 h-4 text-[#d9a15b]" />{soldOut ? 'No beds left' : `${tier.available} of ${tier.capacity} beds open`}</li>
            </ul>
            <span className={`inline-flex w-full items-center justify-center gap-2 rounded-full py-3 text-sm font-semibold transition-colors
              ${soldOut ? 'bg-gray-100 text-gray-400' : featured ? 'bg-[#d9a15b] text-[#1a0d10] group-hover:bg-[#f0d3a0]' : 'bg-gradient-to-r from-wine to-burgundy text-white group-hover:opacity-90'}`}>
              {soldOut ? 'Sold out' : 'Hold this bed'}
              {!soldOut && <ArrowRight className="w-4 h-4 transition-transform group-hover:translate-x-0.5" />}
            </span>
          </div>
        </button>
      );
    })}
  </div>
);
